<template>
  <div class="d-flex justify-center align-center">
    <template v-if="survived">
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="14"
          cy="14"
          r="11.5714"
          fill="#65D069"
          stroke="#65D069"
          stroke-width="0.857143"
        />
        <path
          d="M18.6667 11L12.6 17.9333L10 15.3333"
          stroke="white"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </template>

    <template v-else>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="14"
          cy="14"
          r="11.5714"
          fill="#E42525"
          stroke="#E42525"
          stroke-width="0.857143"
        />
        <g clip-path="url(#clip0_2880_23467)">
          <path
            d="M16.6668 11.3333L11.3335 16.6666M16.6668 16.6666L11.3335 11.3333L16.6668 16.6666Z"
            stroke="white"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2880_23467">
            <rect
              width="8"
              height="8"
              fill="white"
              transform="translate(18 18) rotate(-180)"
            />
          </clipPath>
        </defs>
      </svg>
    </template>
  </div>
</template>

    <script>
export default {
  name : 'CrisisSurvivalIcon',
  props: {
    survived: {
      type   : Boolean,
      default: false
    },
    color: {
      type   : String,
      default: '#ffffff'
    },
    size: {
      type   : [String, Number],
      default: 24
    }
  }
}
    </script>

    <style scoped />
